import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { CalendarClock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtEur = (v) => new Intl.NumberFormat("de-AT", { style: "currency", currency: "EUR" }).format(v || 0);

// Jahres-Check (ab 2. Jänner): hinterlegten Kammerbeitrag prüfen oder unverändert bestätigen.
export const LexKammerBanner = ({ onReview, refreshKey = 0 }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/lex/honorar/extras-default/status`).then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, [refreshKey]);

  if (!status?.review_due) return null;

  const confirm = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/lex/honorar/extras-default/confirm`);
      toast.success(`Kammerbeitrag für ${status.year} bestätigt.`);
      setStatus({ ...status, review_due: false });
    } catch {
      toast.error("Bestätigung fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lex-card p-5 mb-6 flex flex-col sm:flex-row sm:items-center gap-4 border-l-4" style={{ borderLeftColor: "#C5A059" }}
      data-testid="lex-kammer-banner">
      <CalendarClock className="h-5 w-5 shrink-0" style={{ color: "#C5A059" }} />
      <div className="flex-1">
        <p className="text-sm font-semibold text-slate-800">Kammerbeiträge {status.year} prüfen</p>
        <p className="text-xs text-slate-500 mt-0.5">
          Hinterlegt sind <span className="lex-mono">{fmtEur(status.kammer_20)}</span> netto pro laufender Note. Stimmt der Betrag noch für {status.year}?
        </p>
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={confirm} disabled={busy}
          className="text-xs uppercase tracking-wider font-semibold px-3 py-2 border border-slate-200 text-slate-600 hover:border-[#C5A059] transition-colors disabled:opacity-50"
          data-testid="lex-kammer-confirm">{busy ? "…" : "Unverändert bestätigen"}</button>
        <button type="button" onClick={() => (onReview ? onReview() : navigate("/lex/honorar"))} className="lex-btn !px-4 !py-2 text-xs"
          data-testid="lex-kammer-review">Betrag anpassen</button>
      </div>
    </div>
  );
};

export default LexKammerBanner;
